import "../../App.css";
import "../../styling/Events.css";
import May30Show from "../../images/events/May_30_show.jpg";

// Boostrap Imports
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";

// Previous Events imports
import PreviousEvents from "./PreviousEvents";

import { useState, useEffect } from "react";

function Events() {
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(false);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
    if (window.innerWidth <= 768) {
      // Adjust breakpoint as needed
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    // Initial check on mount
    handleWindowSizeChange();
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  return (
    <div id="events_page" className="events_background">
      <h3 className="title_header">EVENTS</h3>
      <Tab.Container defaultActiveKey="first" className="tab_header">
        <Row className="tab_header">
          <Col>
            <Nav
              className="justify-content-center option_header"
              variant="underline"
            >
              <Nav.Item>
                <Nav.Link eventKey="first">UPCOMING EVENTS</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col>
            <Nav
              className="justify-content-center option_header"
              variant="underline"
            >
              <Nav.Item>
                <Nav.Link eventKey="second">PREVIOUS EVENTS</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Tab.Content>
            <Tab.Pane eventKey="first">
              <Container className="tab_header">
                <Row>
                  <Col sm={8}>
                    <h4>UPCOMING EVENTS</h4>
                    {isMobile ? (
                      <Col sm={4}>
                        <img className="tab_image" src={May30Show} alt=""></img>
                      </Col>
                    ) : (
                      <div />
                    )}
                    <Row className="tab_content_left">
                      <Col sm={4}>
                        <h5>THAT SHOW</h5>
                        <h6>May 30th</h6>
                        {/* <h6>Doors at 6:30pm</h6>
                        <h6>Performances begins at 7pm</h6> */}
                        {/* <br></br> */}
                        <p>
                          Judson Memorial Church - “The Gym”<br></br>243
                          Thompson Street <br></br>New York, NY 10012
                        </p>
                        <a href="https://www.eventbrite.com/e/that-show-may-30-2026-tickets-1987738297757">
                          Tickets
                        </a>
                      </Col>
                      <Col sm={1}></Col>
                      <Col sm={7}>
                        <p>
                          <b>
                            <i>Artists Featured</i>
                          </b>
                        </p>
                        <p>
                          Hardy Party{" "}
                          <a href="https://www.instagram.com/hannahbananahardy/">
                            @hannahbananahardy
                          </a>
                          <br></br>
                          Faride Henaine Gutiérrez{" "}
                          <a href="https://www.instagram.com/_faridehg/">
                            @_faridehg
                          </a>
                          <br></br>
                          Yael Haskal{" "}
                          <a href="https://www.instagram.com/yael_haskal/">
                            @yael_haskal
                          </a>
                          <br></br>
                          Brooke Lutz{" "}
                          <a href="https://www.instagram.com/brookelutz_/">
                            @brookelutz_
                          </a>
                          <br></br>
                          Elizabeth Buchheister and Company{" "}
                          <a href="https://www.instagram.com/lizbdancer/">
                            @lizbdancer
                          </a>
                          <br></br>
                          Anna Hershinow & Julia Asher{" "}
                          <a href="https://www.instagram.com/juliaasher_/">
                            @juliaasher_
                          </a>{" "}
                          <a href="https://www.instagram.com/anna.hershinow/">
                            @anna.hershinow
                          </a>
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  {!isMobile ? (
                    <Col sm={4}>
                      <img className="tab_image" src={May30Show} alt=""></img>
                    </Col>
                  ) : (
                    <div />
                  )}
                </Row>
              </Container>
            </Tab.Pane>
            <Tab.Pane eventKey="second">
              <PreviousEvents />
            </Tab.Pane>
          </Tab.Content>
        </Row>
      </Tab.Container>
    </div>
  );
}

export default Events;
